// extracted by mini-css-extract-plugin
module.exports = {"container":"PackFilter_container__1ejAE","content":"PackFilter_content__2Su4t"};